import styled, { keyframes } from 'styled-components'

const scaleEntrada = keyframes`
  from {
    transform: translateY(-50%) rotate(-15deg) scale(0.8);
    opacity: 0;
  }
  to {
    transform: translateY(-50%) rotate(-15deg) scale(1);
    opacity: 0.05;
  }
`
const fadeInSurgir = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const DetalheSection = styled.section`
  display: flex;
  padding: 40px;
  padding-bottom: 120px;
  background-color: ${(props) =>
    props.theme.azulEscuro}; /* Fundo profundo para contraste */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  margin: 0 auto;

  .icone-fundo-card {
    position: absolute;
    top: 50%;
    right: -100px; /* Puxa ele para dentro do card, mas cortando um pouco */
    transform: translateY(-50%) rotate(-15deg); /* Dá uma leve inclinada estilosa */
    z-index: 0; /* Garante que fique atrás do texto */
    opacity: 0.05; /* Deixa ele bem clarinho para não atrapalhar a leitura */
    pointer-events: none; /* Evita que o ícone interfira nos cliques */
    animation: ${scaleEntrada} 0.8s ease-out 0.2s forwards;
    opacity: 0;

    svg {
      width: 450px; /* Mantém o tamanho gigante que você conseguiu */
      height: 450px;
      color: #fff;
    }

    @media (max-width: 768px) {
      right: -50px; /* Traz ele mais para dentro no mobile */

      svg {
        width: 250px; /* Diminui o tamanho para não "explodir" o card no celular */
        height: 250px;
      }
    }
  }

  .conteudo {
    position: relative;
    overflow: hidden;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    max-width: 600px;
    width: 100%;
    gap: 60px;
    background: ${(props) => props.theme.azulPrincipal}; /* Cor do box da Bio */
    padding: 50px;
    border-radius: 24px;
    border: 1px solid ${(props) => props.theme.azulDestaque};
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
    animation: ${fadeInSurgir} 0.5s ease-out forwards;

    @media (max-width: 768px) {
      flex-direction: column-reverse; /* Imagem em cima no celular */
      text-align: center;
      padding: 30px;
    }
  }

  .texto {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;

    h2 {
      font-size: 42px;
      color: ${(props) => props.theme.azulMuitoClaro};
      margin-bottom: 20px;
      font-weight: 800;
    }

    p {
      font-size: 18px;
      color: ${(props) => props.theme.azulClaro};
      line-height: 1.8;
      margin-bottom: 30px;
    }

    .btn-contato {
      background-color: ${(props) => props.theme.azulAcentuado};
      color: white;
      padding: 16px 35px;
      border-radius: 12px;
      border: none;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);

      &:hover {
        transform: translateY(-3px);
        filter: brightness(1.2);
        box-shadow: 0 8px 25px rgba(52, 152, 219, 0.5);
      }
    }
  }

  .midia {
    flex: 1;
    display: flex;
    justify-content: center;

    img {
      max-width: 100%;
      height: 450px;
      object-fit: cover;
      border-radius: 20px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .lista-topicos {
    list-style: none;
    padding: 0;
    margin: 25px 0 35px 0; /* Espaçamento entre texto e botão */
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      color: ${(props) => props.theme.azulClaro};
      font-size: 16px;
    }
  }

  a {
    text-decoration: none;
  }
`
